import { connect } from 'react-redux';
import { SafeRentDescription } from './SafeRentDescription';
import { prefetchFormState } from '../../store/deal-rent';
import { IState } from '../../store';

export function mapStateToProps(state: IState) {
  return {
    id: state.offerData.offer.id,
  };
}

export const SafeRentDescriptionContainer = connect(mapStateToProps, { openModal: prefetchFormState })(
  SafeRentDescription,
);
